module.exports = __webpack_public_path__ + "img/newsExperience2.206bbe74.png";